(function (t) {
// fr
t.add("label_previous", "Pr\u00e9c\u00e9dent", "KnpPaginatorBundle", "fr");
t.add("label_next", "Suivant", "KnpPaginatorBundle", "fr");
})(Translator);
